module.exports = __webpack_public_path__ + "img/lucina-min.0af23b09.png";